import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import Preloader from '../../user/Preloader';
import { API_URL, APP_URL, FILE_URL, NO_IMG } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import ChangePassword from './ChangePassword';
import LoadingDashboardContent from '../../components/LoadingDashboardContent';
import { useTokens } from '../../context/TokenContext';
import { Reload } from '@rsuite/icons';
import VendorOverview from './VendorOverview';
import EditPickupLocation from './EditPickupLocation';
import EditProfile from './EditPersonalInfo';
import EditBankInfo from './EditBankInfo';

const Addresses = () => {
  return <div>Addresses Page</div>;
};

const UpdatePassword = () => {
  return <div>Update Password Page</div>;
};

const fetchUserData = async (id, setLoading, setFormData, vendorAuthToken) => {
  setLoading(true);
  setFormData({});
  try {
    const response = await axios.get(`${API_URL}/vendor/get`, {
      headers: {
        'Authorization': `Bearer ${vendorAuthToken}`,
      },
    });

    if (response.status === 200) {
      setFormData(response.data);
    }
  } catch (error) {
    toast.error('Failed to fetch user data. Please try again.', {
      position: 'top-right',
    });
  } finally {
    setLoading(false);
  }
};

const AdminVendorEdit = ({ id }) => {
  const { getItem } = useTokens();
  const vendorAuthToken = getItem('vendor', 'AuthToken');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { pathname, search } = useLocation();
  const [formData, setFormData] = useState(true);
  const [isReload, setIsReload] = useState(false);

  useEffect(() => {
    fetchUserData(id, setLoading, setFormData, vendorAuthToken);
  }, [id, isReload]);

  const userName = formData ? `${formData.first_name} ${formData.last_name}` : '';
  const userRole = formData ? formData.roles : '';
  const profilePicture = formData ? formData.profile_picture : '';

  const handleEditProfile = () => {
    alert('Navigating to /profile/edit for vendor ');
  };

  const handleGoBack = () => {
    alert('Going back to previous page...');
  };

  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Edit Vendor</h1>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Link to={`${APP_URL}vendor/vendor`}>
            <button type="button" className="btn btn-sm btn-outline-secondary rounded-0">
              <i className="bi bi-arrow-left me-2"></i> Back to List
            </button>
          </Link>
        </div>
      </div>

      {loading ? <LoadingDashboardContent /> : (
        <div className="row g-4 pt-1">
          <div className="col-md-3 col-lg-3">
            <div className="card mb-4">
              <div className="align-items-center d-flex">
                <div>
                  <img
                    src={profilePicture && profilePicture.trim() !== '' ? `${FILE_URL}${profilePicture}` : NO_IMG}
                    className="img-fluid rounded-circle ratio-1x1 img-thumbnail object-fit-cover"
                    alt="User Avatar"
                    style={{ width: 80, height: 80 }}
                  />
                </div>
                <div>
                  <div className="card-body p-2">
                    <span className="small text-muted fwt-italic">Hello,</span>
                    <h6 className="text-muted m-0 p-0">{userName}</h6>
                    <span className="small text-info" style={{ 'fontSize': 12 }}>Seller Account</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <ul className="list-group list-group-flush">
                <li className="list-group-item list-group-item-action">
                  <Link to={`${APP_URL}vendor/profile/overview`} className="d-block text-dark text-decoration-none">
                    <i className="bi bi-speedometer"></i> Overview
                  </Link>
                </li>
                <li className="list-group-item list-group-item-action">
                  <Link to={`${APP_URL}vendor/profile/edit-profile`} className="d-block text-dark text-decoration-none">
                    <i className="bi bi-person"></i> Personal Profile
                  </Link>
                </li>
                <li className="list-group-item list-group-item-action">
                  <Link to={`${APP_URL}vendor/profile/edit-warehouse`} className="d-block text-dark text-decoration-none">
                    <i className="bi bi-geo-alt"></i> Pickup Address
                  </Link>
                </li>
                <li className="list-group-item list-group-item-action">
                  <Link to={`${APP_URL}vendor/profile/edit-bankinfo`} className="d-block text-dark text-decoration-none">
                    <i className="bi bi-bank"></i> Bank Information
                  </Link>
                </li>
                <li className="list-group-item list-group-item-action">
                  <Link to={`${APP_URL}vendor/profile/change-password`} className="d-block text-dark text-decoration-none">
                    <i className="bi bi-fingerprint"></i> Security
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-9 col-lg-9">
            <div className="card">
              <div className="card-body p-4">
                {loading ? (
                  <Preloader />
                ) : (
                  <>
                    <Routes>
                      <Route path="/" element={<VendorOverview vendorData={formData} onEditProfile={handleEditProfile} onGoBack={handleGoBack} Reload={() => setIsReload(!isReload)} />} />
                      <Route path="overview" element={<VendorOverview vendorData={formData} onEditProfile={handleEditProfile} onGoBack={handleGoBack} Reload={() => setIsReload(!isReload)} />} />
                      <Route path="edit-profile" element={<EditProfile vendorData={formData} onReload={() => setIsReload(!isReload)} />} />
                      <Route path="edit-warehouse" element={<EditPickupLocation vendorData={formData} onReload={() => setIsReload(!isReload)} />} />
                      <Route path="edit-bankinfo" element={<EditBankInfo vendorData={formData} onReload={() => setIsReload(!isReload)} />} />
                      <Route path="change-password" element={<ChangePassword />} />
                    </Routes>

                    {/* This Outlet renders the nested route content */}
                    <Outlet />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminVendorEdit;
